import { render, staticRenderFns } from "./UsersListFilters.vue?vue&type=template&id=0b70b2d8&"
import script from "./UsersListFilters.vue?vue&type=script&lang=js&"
export * from "./UsersListFilters.vue?vue&type=script&lang=js&"
import style0 from "./UsersListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports